import React from 'react';
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';

const cardData = [
  {
    icon: '🎯',
    title: 'Faites partie des profils les plus recherchés',
    description:
      "Les entreprises tech cherchent des développeurs capables de coder ET d'exploiter l'IA. Les recruteurs veulent des profils qui maîtrisent les fondamentaux.",
  },
  {
    icon: '💰',
    title: 'Accédez à des opportunités mieux rémunérées',
    description:
      "Le développement fait partie des compétences les plus valorisées. Maîtrisez le code et l'IA pour accéder aux postes les mieux payés du secteur tech.",
  },
  {
    icon: '⚡',
    title: "Utilisez l'IA comme un accélérateur",
    description:
      "L'IA multiplie votre productivité, mais seulement si vous savez coder. Sans bases solides, vous ne pourrez ni comprendre ce qu'elle génère, ni corriger ses erreurs.",
  },
  {
    icon: '🚀',
    title: "Prenez une longueur d'avance sur votre avenir",
    description:
      "Savoir coder reste irremplaçable. Formez-vous avec une vraie méthode : projets concrets, portfolio solide, et maîtrise des outils qui comptent vraiment.",
  },
];

const WhyLearnCodeSection = () => {
  return (
    <section
      css={{
        padding: '5rem 2rem',
        background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
        position: 'relative',
        overflow: 'hidden',
        [mediaQueries.phoneOnly]: {
          padding: '3rem 1rem',
        },
      }}
    >
      {/* Background decoration */}
      <div
        css={{
          position: 'absolute',
          top: '-50%',
          right: '-10%',
          width: 500,
          height: 500,
          background: 'radial-gradient(circle, rgba(251, 191, 36, 0.3) 0%, transparent 70%)',
          borderRadius: '50%',
          pointerEvents: 'none',
        }}
      />

      <div
        css={{
          maxWidth: 1200,
          margin: '0 auto',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {/* Section Title */}
        <h2
          css={{
            textAlign: 'center',
            fontSize: '2.5rem',
            marginBottom: '3rem',
            color: colors.purpleDark,
            fontWeight: 700,
            [mediaQueries.phoneOnly]: {
              fontSize: '1.75rem',
              marginBottom: '2rem',
            },
          }}
        >
          Pourquoi apprendre à coder{' '}
          <span css={{ color: colors.purple }}>à l'ère de l'IA ?</span>
        </h2>

        {/* Cards Grid */}
        <div
          css={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '2rem',
            [mediaQueries.tabletLandscapeUp]: {
              gridTemplateColumns: 'repeat(4, 1fr)',
            },
            '@media only screen and (max-width: 1199px)': {
              gridTemplateColumns: 'repeat(2, 1fr)',
            },
            [mediaQueries.phoneOnly]: {
              gridTemplateColumns: '1fr',
              gap: '1.5rem',
            },
          }}
        >
          {cardData.map((card, index) => (
            <div
              key={index}
              css={{
                backgroundColor: colors.white,
                padding: '2rem',
                borderRadius: 16,
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 12px 30px rgba(0, 0, 0, 0.15)',
                },
                [mediaQueries.phoneOnly]: {
                  padding: '1.5rem',
                },
              }}
            >
              {/* Card Icon */}
              <div
                css={{
                  width: 60,
                  height: 60,
                  background: `linear-gradient(135deg, ${colors.purple} 0%, ${colors.purpleLight} 100%)`,
                  borderRadius: 12,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.75rem',
                  marginBottom: '1.5rem',
                }}
              >
                {card.icon}
              </div>

              {/* Card Title */}
              <h3
                css={{
                  fontSize: '1.35rem',
                  marginBottom: '1rem',
                  color: colors.purpleDark,
                  fontWeight: 700,
                  lineHeight: 1.3,
                  [mediaQueries.phoneOnly]: {
                    fontSize: '1.2rem',
                  },
                }}
              >
                {card.title}
              </h3>

              {/* Card Description */}
              <p
                css={{
                  color: colors.darkGrey,
                  lineHeight: 1.7,
                  margin: 0,
                  fontSize: '1rem',
                }}
              >
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyLearnCodeSection;
